module.exports = __webpack_public_path__ + "static/media/youtube.2d64b070.svg";